import { ReactKeycloakProvider } from '@react-keycloak/web';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { isDev, isStage } from '../../../config';
import keycloak from '../../../keycloak';
import { keycloakMessage, Tokens } from '../../../store/keycloak';

export const KeycloakProvider = ({ children }: { children: JSX.Element }) => {
    const dispatch = useDispatch();

    const handleEvent = (event: string | unknown = 'onReady') => dispatch(keycloakMessage({ event: event }));

    const eventLogger = (event: string | unknown) => handleEvent(event);

    const tokenLogger = (tokens: Tokens | unknown) => dispatch(keycloakMessage({ tokens: tokens as Tokens }));

    /* eslint-disable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,react-hooks/exhaustive-deps */
    const handleTokensFromWindow = () =>
        dispatch(
            keycloakMessage({
                tokens: {
                    refreshToken: (window as any).keycloak.refreshToken,
                    token: (window as any).keycloak.token,
                    idToken: (window as any).keycloak.idToken,
                },
            })
        );

    useEffect(() => {
        (window as any).addEventListener('keycloakReadyEvent', () => handleEvent());
        (window as any).addEventListener('djangoTokensRefreshed', handleTokensFromWindow);

        return () => {
            (window as any).removeEventListener('keycloakReadyEvent', () => handleEvent());
            (window as any).removeEventListener('djangoTokensRefreshed', handleTokensFromWindow);
        };
    }, []);

    if (isDev || isStage) {
        return children;
    } else if (process.env.REACT_APP_MODE === 'django') {
        (window as any).addEventListener('djangoScriptsReady', () => {
            if ((window as any).keycloakReadyDjango !== true && !(window as any).isKeycloakInitialising) {
                (window as any).checkKeycloakStatus();
            }
        });

        return children;
    } else {
        return (
            <ReactKeycloakProvider
                authClient={keycloak}
                onEvent={eventLogger}
                onTokens={tokenLogger}
                initOptions={{
                    onLoad: 'check-sso',
                    flow: 'hybrid',
                    silentCheckSsoRedirectUri: `${window.location.origin}${process.env.REACT_APP_SILENT_URL || ''}`,
                }}
            >
                {children}
            </ReactKeycloakProvider>
        );
    }
    /* eslint-enable @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any,react-hooks/exhaustive-deps */
};
